module.exports = "/assets/data/af9d61334cc4e69194d4538a85d54d60-LA20.data.json";